import styled from '@emotion/styled';
import grey from '@mui/material/colors/grey';
import blue from '@mui/material/colors/blue';


export const DocsBar = styled.div`
   flex-basis: 240px;
    flex-grow: 0;
    flex-shrink: 0;
  height: 100%;
  float : left;
  margin-right : 23px;
`;

export const DocsHeader = styled.div`
  height : 60px;
  width : 100%;
  border: 1px solid ${grey[300]};
  background : ${grey[200]};
  
  h2 {
    margin : 0;
    box-sizing : border-box;
    padding : 0px 23px;
    line-height : 50px;
    font-size : 17px;
    color : ${grey[700]};
  }
`;

export const DocsBody = styled.div`
  width : 100%;
  height: calc(100vh - 120px);
  background : ${grey[50]};
  border-left : 1px solid ${grey[300]};
  border-right: 1px solid ${grey[300]};
  box-sizing : border-box;
  padding : 13px 0px;
`;

export const DocsList = styled.ul`
  list-style : none;
`;

export const DocsItem = styled.li`
  font-size :  ${props => props.isSub ? '13px' : '15px'};
  height : 20px;
  line-height : 20px;
  display : flex;
  align-items : center;
  
  
  position : relative;
  left : ${props => props.isSub ? '14px' : null};
  cursor : pointer;
   
  text-decoration : none;
  color :  ${props => props.isActive ? blue[500] : blue[300]};
  font-weight : ${props => props.isActive ? 600 : null};
  
  svg {
    margin-right : 5px;
    color :  ${props => props.isActive ? blue[500] : blue[300]};
  }
`;